module.exports = __webpack_public_path__ + "img/tiktok-viewer-mini.e0e5168a.svg";